import React, { useState, useEffect, useContext, use, } from "react";

import { Modal, Col, Row, Button, NavItem, NavLink, Dropdown, DropdownMenu, DropdownItem, DropdownToggle, ButtonDropdown, Container, Card, CardBody, CardTitle, } from "reactstrap";
import { MoondanceContext } from '../../App';

import UseMoondanceApi from "../lib/api";
import Form from 'react-bootstrap/Form';
import MoondanceLayout from '../lib/layout.js';
import { useParams, Link, useNavigate } from 'react-router-dom';
import Select from 'react-select';

export default function AccountWidget(props) {
    const moondanceApi = UseMoondanceApi();
    const { accountList } = useContext(MoondanceContext);
    const { selectedAccountList, setSelectedAccountList } = useContext(MoondanceContext);
    const { selectedStatus, setSelectedStatus } = useContext(MoondanceContext);

    const { userCurrency } = useContext(MoondanceContext);
    const { darkMode } = useContext(MoondanceContext);
    const [tmpSelectedAccountList, setTmpSelectedAccountList] = useState([]);
    const [tmpSelectedStatusList, setTmpSelectedStatusList] = useState([]);
    const [showRefresh, setShowRefresh] = useState(false);
    const [accountChanged, setAccountChanged] = useState(false);
    const [statusChanged, setStatusChanged] = useState(false);


    const [ userId, setUserId ] = useState(null);
    const { lastUpdate, setLastUpdate } = useContext(MoondanceContext);
    const navigate = useNavigate();
    const [expanded, setExpanded] = useState((props.expanded ? props.expanded : false))

    const formatOptionLabel = (option, { context }) => {
        if (context === "menu") {
            return (
                <div>
                    <div>{option.label}</div>
                </div>); // customize your option label for the dropdown menu here
        }
        return <div>{option.label}</div>; // for singleValue (the label when an option is selected)
    };
    useEffect(() => {
        setTmpSelectedAccountList(selectedAccountList)
        setTmpSelectedStatusList(selectedStatus)
    }, [selectedAccountList, selectedStatus]);

    useEffect(() => {

        moondanceApi.getLoggedinUser().then(profile => {

            if (profile) {
                setUserId(profile.data.id);
            } else {
                console.log('No user found');
                setUserId(null);
            }
        }).catch(error => {
            console.log(error)
        });
    }, []);

    const setAsDefault = () => {
        console.log(tmpSelectedAccountList,accountList)

        if (userId !== null) {
            accountList.forEach(function (account) {
                if (tmpSelectedAccountList.some((item) => item.value === account.value)) {
                    account.selectedByDefault = 1;
                } else {
                    account.selectedByDefault = 0;
                }

                var requestData = {
                    id: parseInt(account.value),
                    selectedByDefault: (account.selectedByDefault ? account.selectedByDefault : 0),
                    uid: parseInt(userId),
                }
                moondanceApi.updateUserAccountsSelection(requestData).then(response => {
                    console.log(response)
                })
                    .catch(error => {
                        console.log(error)
                    });
            })
        }
    }

        
    const triggerRefresh = () => {
        const accountsChanged = JSON.stringify(tmpSelectedAccountList) !== JSON.stringify(selectedAccountList);
        const statusChanged = JSON.stringify(tmpSelectedStatusList) !== JSON.stringify(selectedStatus);

        if (accountsChanged) {
            setSelectedAccountList(tmpSelectedAccountList);
            localStorage.setItem('selectedAccount', JSON.stringify(tmpSelectedAccountList));
        }

        if (statusChanged) {
            setSelectedStatus(tmpSelectedStatusList);
            localStorage.setItem('selectedStatus', JSON.stringify(tmpSelectedStatusList));
        }

        if (accountsChanged || statusChanged) {
            setLastUpdate(Math.floor(Date.now()));
        }
        setAccountChanged(false);
        setStatusChanged(false);
        if(props && !props.expanded) {
            setExpanded(false);
        } else{
            console.log('navigate')
            navigate('/dashboard/summary')
        }
         // always collapse regardless
    };


    const selectAccountUpdate = (index, action, event) => {

        //console.log('selectAccountUpdate', index, action, event    )
        if (action === "select") {
            // Find the selected element in accountList
            const selectedElement = accountList[index];

            // Add it to the selectedAccountList (if it's not already present)
            if (!tmpSelectedAccountList.some((item) => item.value === selectedElement.value)) {
                setTmpSelectedAccountList((prevSelected) => [...prevSelected, selectedElement]);
            }
        } else if (action === "unselect") {
            // Find the selected element in selectedAccountList based on some unique identifier (e.g., value)
            const selectedElement = accountList[index];

            // Find the index of the element to remove from selectedAccountList
            const removeIndex = tmpSelectedAccountList.findIndex((item) => item.value === selectedElement.value);

            if (removeIndex !== -1) {
                setTmpSelectedAccountList((prevSelected) =>
                    prevSelected.filter((item, idx) => idx !== removeIndex)
                );
            }
        }

        setShowRefresh(true)
    };
    const selectStatusUpdate = (index, action, event) => {

        if (action === "select") {
            // Find the selected element in statusList
            const selectedElement = MoondanceLayout.statusList[index];

            // Add it to the selectedStatus (if it's not already present)
            if (!tmpSelectedStatusList.some((item) => item.value === selectedElement.value)) {
                setTmpSelectedStatusList((prevSelected) => [...prevSelected, selectedElement]);
            }
        } else if (action === "unselect") {
            // Find the selected element in selectedStatus based on some unique identifier (e.g., value)
            const selectedElement = MoondanceLayout.statusList[index];

            // Find the index of the element to remove from selectedStatus
            const removeIndex = tmpSelectedStatusList.findIndex((item) => item.value === selectedElement.value);

            if (removeIndex !== -1) {
                setTmpSelectedStatusList((prevSelected) =>
                    prevSelected.filter((item, idx) => idx !== removeIndex)
                );
            }
        }

        setShowRefresh(true)
    };


    return (
        <React.Fragment>

            {(expanded && accountList ?
                <>
                    <Row >
                        <Col sm="12">
                            {(props && props.expanded) ?<Form.Label >Account(s) :</Form.Label> : ''}
                            <Select
                                 isMulti
                                isClearable={false}
                                closeMenuOnSelect={false}
                                value={tmpSelectedAccountList}
                                onChange={(selected) => {
                                    if (!selected || selected.length === 0) return; // enforce at least one
                                    setTmpSelectedAccountList(selected);
                                    setAccountChanged(true)
                                }}
                                options={accountList}
                                placeholder="Select Accounts"
                                formatOptionLabel={formatOptionLabel}
                                styles={MoondanceLayout.select2customStyles}
                                style={{ zIndex: 10000 }}
                                classNamePrefix="select2-selection"
                            />
                             {(props && props.expanded) ?<Form.Label style={{marginTop:'1em',marginBottom:'1em'}}>Status :</Form.Label> : <div  style={{ marginTop: '0.5em' }}></div>}
                             
                            <Select
                                isMulti
                                isClearable={false}
                                closeMenuOnSelect={false}
                                value={tmpSelectedStatusList}
                                onChange={(selected) => {
                                    if (!selected || selected.length === 0) return; // enforce at least one
                                    setTmpSelectedStatusList(selected);
                                    setStatusChanged(true)
                                }}
                                options={MoondanceLayout.statusList}
                                placeholder="Select Status"
                                formatOptionLabel={formatOptionLabel}
                                styles={MoondanceLayout.select2customStyles}
                                style={{ zIndex: 10000 }}
                                classNamePrefix="select2-selection"
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="6">
                        {(accountChanged  ?
                            <button
                                onClick={setAsDefault}
                                className="btn btn-info btn-sm"
                                style={{ marginTop: '0.5em',width: '100%' }}
                            >
                                Set as default
                            </button>
                            : null)}
                        </Col>
                        <Col sm="6">
                            {(accountChanged || statusChanged || (props && props.expanded)) ?
                            <button
                                onClick={triggerRefresh}
                                className="btn btn-primary btn-sm"
                                style={{ marginTop: '0.5em', width: '100%' }}
                            ><span className="mdi mdi-refresh"></span>  Apply Filters
                            </button> :
                           ((props && !props.expanded) ? <button
                                onClick={triggerRefresh}
                                className="btn btn-outline-primary btn-sm"
                                style={{ marginTop: '0.5em', width: '100%' }}
                            ><span className="mdi mdi-close"></span> 
                                Close
                            </button> :'')
                            }
                        </Col>


                    </Row>
                </>
                :
                <>
                    <div style={{ fontSize: '0.8em', marginBottom: '0em', lineHeight: '1.5em' }}>
                        <b>Selected Account(s) :</b> {MoondanceLayout.displayArrayLabels(selectedAccountList)}<br />
                        <b>Selected Status :</b> {MoondanceLayout.displayArrayLabels(selectedStatus)}<br />
                        <b>Currency :</b> {userCurrency}<br />
                        <button className="btn btn-outline-primary btn-sm" style={{ fontSize: '1em', float: 'right', }} onClick={() => setExpanded(!expanded)}><span class="mdi mdi-filter"></span> Filter</button></div>

                </>
            )}
        </React.Fragment >
        )
    }